module.exports = __webpack_public_path__ + "static/media/ypic-cg-2018.e4f39f18.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/docs/ypic-cg-2018.pdf
// module id = 790
// module chunks = 2